import API from '../api'
export { default as GlossaryFetcher } from './fetcher'
export const GlossarySave = ( url, data ) => API.post(url, data ).then(res => res.data )
export const LoginPost = ( url, data ) => API.post(url, data ).then(res => res )